import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { setUser, setError } from '../../redux/authSlice';
import { Input } from "../ui/Input";
import { Label } from "../ui/Label";

const RegistrationForm = () => {
  const [visible, setVisible] = useState(false);
  const [match, checkMatch] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    if (data.password !== data.passwordRepeat) {
      checkMatch(false);
    } else {
      checkMatch(true);
      delete data.passwordRepeat;

      try {
        const rawResponse = await fetch("/api/users/register", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        });

        if (rawResponse.ok) {
          // Выполняем вход после успешной регистрации
          const loginResponse = await fetch('/api/perform_login', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email: data.email, password: data.password }),
            credentials: 'include',
          });

          if (!loginResponse.ok) {
            const errorContent = await loginResponse.json();
            dispatch(setError(errorContent.message || 'Ошибка входа'));
            return;
          }

          const userData = await loginResponse.json();
          dispatch(setUser({
            user: userData.user,
            roles: userData.roles || [],
            permissions: userData.permissions || [],
          }));

          navigate("/registrationSuccess"); // Переход на страницу успешной регистрации
        } else if (rawResponse.status === 409) {
          const error = await rawResponse.text();
          alert(error);
        } else {
          alert("Произошла неизвестная ошибка. Попробуйте снова позже.");
        }
      } catch (error) {
        console.error("Ошибка при регистрации:", error);
        alert("Произошла ошибка. Попробуйте еще раз.");
      }
    }
  };

  const toggleVisibility = () => setVisible(!visible); // Логика для показа/скрытия пароля

  return (
      <div className="mx-auto mt-20 max-w-3xl px-4 pb-16">
        <div className="mb-8 text-center">
          <img src="/images/lksm.png" alt="ЛКСМ РФ" className="mx-auto mb-4 h-16 w-auto rounded-xl bg-white p-1 shadow" />
          <h1
              className="text-4xl text-neutral-800"
              style={{ fontFamily: "Ysabeau SC" }}
          >
            Регистрация на сайте
          </h1>
        </div>

        <form
            className="rounded-2xl bg-white p-8 shadow-[0_4px_10px_rgba(0,0,0,0.1)]"
            onSubmit={handleSubmit(onSubmit)}
        >
          {/* Поле для электронной почты */}
          <div className="mb-6">
            <Label htmlFor="email">E-mail</Label>
            <div className="mt-1.5">
              <Input
                  id="email"
                  type="email"
                  placeholder="name@example.ru"
                  {...register("email", { required: true })}
              />
            </div>
            {errors.email && (
                <p className="mt-1 text-xs text-red-600">E-mail обязателен</p>
            )}
          </div>

          {/* Поля для пароля */}
          <div className="mb-6 flex flex-col overflow-hidden rounded-xl border border-neutral-200 bg-neutral-50 md:flex-row">
            <div className="p-4 md:flex-1">
              <p className="text-xl font-bold text-neutral-800">
                Придумайте пароль
              </p>
              <p className="mt-2 text-sm text-neutral-600">
                Условия: латинские символы, минимум одна заглавная и одна
                маленькая буквы, одна цифра. Минимальная длина — 8 символов.
              </p>
            </div>
            <div className="space-y-3 p-4 md:flex-1">
              <div className="relative">
                <Input
                    id="password"
                    type={visible ? "text" : "password"}
                    placeholder="Пароль"
                    pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
                    className={match ? "" : "focus-visible:ring-red-500"}
                    {...register("password", { required: true })}
                />
                <button
                    type="button"
                    onClick={toggleVisibility}
                    aria-label={visible ? "Скрыть пароль" : "Показать пароль"}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-neutral-400 transition hover:text-neutral-600"
                >
                  {visible ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>

              <div className="relative">
                <Input
                    id="passwordRepeat"
                    type={visible ? "text" : "password"}
                    placeholder="Повторите пароль"
                    className={match ? "" : "focus-visible:ring-red-500"}
                    {...register("passwordRepeat", { required: true })}
                />
                <button
                    type="button"
                    onClick={toggleVisibility}
                    aria-label={visible ? "Скрыть пароль" : "Показать пароль"}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-neutral-400 transition hover:text-neutral-600"
                >
                  {visible ? <FaEyeSlash /> : <FaEye />}
                </button>
                {!match && (
                    <p className="mt-1 text-xs text-red-600">Пароли не совпадают.</p>
                )}
              </div>
            </div>
          </div>

          <button
              type="submit"
              className="mx-auto block rounded-xl bg-red-600 px-8 py-2.5 text-sm font-semibold text-white transition hover:bg-red-700"
          >
            Зарегистрироваться
          </button>
        </form>
      </div>
  );
};

export default RegistrationForm;